<template>
  <TextField
    :label="$tt('personal_id_number')"
    :rules="[required]"
    :maxlength="MAX_LENGTH"
  />
</template>

<script setup lang="ts">
const MAX_LENGTH = 24;
const { required } = useValidation();
</script>